import './drivers.scss';
import Img from '../../assets/driver-landing.jpg';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const Drivers = () => {
    const history = useHistory();
    return (
        <div style={{backgroundImage: `url(${Img})`}} className="drivers">
            <div data-aos="fade-left" className="box">
                <div className="text">
                    <p className="title">Drive & make more Money moving items from point A to B</p>
                    <p className="para">Join our pool of WEHAUL drivers and respond to pickup requests, set your own prices and work at your own convenience.</p>
                </div>
                <button onClick={() => history.push('/driver')}>Find Out More<i className="fas fa-arrow-right"></i></button>
            </div>
        </div>
    )
}

export default Drivers;